import { Select } from '@cast/design-system';

import { CostReportPriceType } from 'features/cost-report/types/common';

const OPTIONS = [
  {
    label: 'Discounted price',
    value: CostReportPriceType.DEFAULT,
  },
  {
    label: 'List price',
    value: CostReportPriceType.LIST,
  },
];

type PriceTypeSelectProps = {
  priceType: CostReportPriceType;
  updatePriceType: (value: CostReportPriceType) => void;
};

export const PriceTypeSelect = ({
  priceType,
  updatePriceType,
}: PriceTypeSelectProps) => {
  return (
    <Select
      testId="price-type-select"
      options={OPTIONS}
      sx={{ minWidth: '170px' }}
      value={priceType}
      optionValue={(it) => it.value}
      optionLabel={(it) => it.label}
      onChange={(option) => {
        updatePriceType(option.value);
      }}
    />
  );
};
